type DurationUnit =
  | 'years'
  | 'months'
  | 'days'
  | 'hours'
  | 'minutes'
  | 'seconds';

const durationFormats: Record<
  DurationUnit,
  { singular: string; plural: string }
> = {
  years: {
    singular: 'year',
    plural: 'years',
  },
  months: {
    singular: 'month',
    plural: 'months',
  },
  days: {
    singular: 'day',
    plural: 'days',
  },
  hours: {
    singular: 'hr',
    plural: 'hrs',
  },
  minutes: {
    singular: 'min',
    plural: 'min',
  },
  seconds: {
    singular: 'sec',
    plural: 'sec',
  },
};

const formatUnit = (value: number, unit: DurationUnit): string => {
  const format = durationFormats[unit];
  const label = value === 1 ? format.singular : format.plural;
  return `${value} ${label}`;
};

const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
export const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;
const SECONDS_IN_MONTH = 31 * SECONDS_IN_DAY;
const SECONDS_IN_YEAR = 365 * SECONDS_IN_DAY;

const unitToSeconds: Record<DurationUnit, number> = {
  years: SECONDS_IN_YEAR,
  months: SECONDS_IN_MONTH,
  days: SECONDS_IN_DAY,
  hours: SECONDS_IN_HOUR,
  minutes: SECONDS_IN_MINUTE,
  seconds: 1,
};

export const secondsToTimeUnits = (
  seconds = 0,
  format: DurationUnit[]
): string => {
  let remaining = seconds;
  const parts: string[] = [];

  for (const unit of format) {
    const item = Math.floor(remaining / unitToSeconds[unit]);
    const value = item;
    remaining -= item * unitToSeconds[unit];

    if (value > 0) {
      parts.push(formatUnit(value, unit));
    }
  }

  return parts.join(' ') || '';
};
